<template>
  <v-app-bar
    class="accent"
    app
  >
    <v-app-bar-nav-icon
      class="hidden-md-and-up"
      :disabled="$vuetify.breakpoint.mdAndUp"
      @click.stop="handleDrawerToggle"
    />
    <v-btn
      icon
      @click="goBack"
    >
      <v-icon large>
        chevron_left
      </v-icon>
    </v-btn>
    <v-toolbar-title
      class="ml-2 font-weight-medium"
      v-text="$route.meta.title"
    />
    <AppProgressToolbar />
    <div class="flex-grow-1" />
    <v-btn
      icon
      @click="handleFullScreen()"
      v-if="$vuetify.breakpoint.mdAndUp"
    >
      <v-icon>fullscreen</v-icon>
    </v-btn>
  </v-app-bar>
</template>
<script>
import Util from '@/util'
import { eventBus } from '@/main'
import AppProgressToolbar from './AppProgressToolbar'
export default {
  name: 'AppToolbar',
  components: {
    AppProgressToolbar
  },
  methods: {
    handleDrawerToggle () {
      eventBus.$emit('APP_DRAWER_TOGGLED')
    },
    handleFullScreen () {
      Util.toggleFullScreen()
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
